import React from 'react';
import PropTypes from 'prop-types';

function OButton({ active, activeColor, background, border, color }) {
  return (
    <>
      {background && (
        <path
          d="M691.939 267.179C705.136 267.179 715.835 256.48 715.835 243.282C715.835 230.085 705.136 219.386 691.939 219.386C678.741 219.386 668.042 230.085 668.042 243.282C668.042 256.48 678.741 267.179 691.939 267.179Z"
          fill={background}
        />
      )}
      <path
        d="M691.939 267.179C705.136 267.179 715.835 256.48 715.835 243.282C715.835 230.085 705.136 219.386 691.939 219.386C678.741 219.386 668.042 230.085 668.042 243.282C668.042 256.48 678.741 267.179 691.939 267.179Z"
        fill={activeColor}
        fillOpacity={active ? 1 : 0}
      />
      <path
        d="M691.858 226.14C682.397 226.14 674.687 233.839 674.687 243.298C674.687 252.757 682.397 260.456 691.858 260.456C701.313 260.456 709.012 252.757 709.012 243.298C709.012 233.839 701.313 226.14 691.858 226.14ZM691.858 229.556C699.464 229.556 705.597 235.687 705.597 243.298C705.597 250.909 699.464 257.04 691.858 257.04C684.246 257.04 678.102 250.909 678.102 243.298C678.102 235.687 684.246 229.556 691.858 229.556Z"
        fill={color}
      />
      <path
        d="M716.647 243.3C716.647 229.628 705.522 218.503 691.846 218.503C678.177 218.503 667.052 229.628 667.052 243.3C667.052 256.972 678.177 268.092 691.846 268.092C705.522 268.092 716.647 256.972 716.647 243.3ZM712.766 243.3C712.766 254.873 703.42 264.209 691.846 264.209C680.278 264.209 670.933 254.873 670.933 243.3C670.933 231.728 680.278 222.386 691.846 222.386C703.42 222.386 712.766 231.728 712.766 243.3Z"
        fill={border}
      />
    </>
  );
}

OButton.propTypes = {
  active: PropTypes.bool,
  activeColor: PropTypes.string,
  background: PropTypes.string,
  border: PropTypes.string,
  color: PropTypes.string,
};

OButton.defaultProps = {
  active: false,
  activeColor: '#FF0000',
  background: null,
  border: '#6F727C',
  color: '#464A56',
};

export default OButton;
